import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { SgBreadcrumb } from "../components/SgBreadcrumb";
import { SgExplainer } from "../components/SgExplainer";
import { SlugGenerator } from "../components/SlugGenerator";

export function SlugGeneratorPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <SgBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.sg_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.sg_intro()}
          </p>
        </header>

        <SlugGenerator />

        <SgExplainer
          howTo={m.sg_howto()}
          faqs={[
            { q: m.sg_faq1_q(), a: m.sg_faq1_a() },
            { q: m.sg_faq2_q(), a: m.sg_faq2_a() },
            { q: m.sg_faq3_q(), a: m.sg_faq3_a() },
            { q: m.sg_faq4_q(), a: m.sg_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
